
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import FormDataSerializerForUpdate from '../types/FormDataSerializerForUpdate_apps_PTM'


const HOST = `${config.API_HOST}`
/* ['generics.RetrieveAPIView'] */
/* params: encounter, form, 'encounter', 'patient', 'form', 'form_code', 'form_version', 'operating_order_id', 'start_date', 'end_date' */
/* data:  */
const FormDataLatest : 
{
  retrieve: ({params, apiToken, extra}:
             { 
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
} = 
{
  retrieve: async ({params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/apis/PTM/form-data-latest/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default FormDataLatest

